import { useMemo } from 'react';

import i18n from '../../../utils/i18n';
import { makeKey } from '../../../utils/i18n/utils';
import {
  AdBoardDto,
  AdBoardSectionGroupDto,
  DiscussionAdBoardSectionContentDto,
  SectionDto,
} from '../types';

export const GENERAL_DISCUSSION_ID = 'general-discussion';

export const useFilterDropdownOptions = ({
  adBoardData,
  selectedGroup,
  selectedActivity,
}: {
  adBoardData: AdBoardDto;
  selectedGroup: AdBoardSectionGroupDto | undefined;
  selectedActivity: SectionDto | undefined;
}) => {
  const groupOptions = useMemo(() => {
    const baseOptions =
      adBoardData?.sectionGroups?.map((group) => ({
        label: `Section ${group.index + 1}: ${group.title}`,
        value: group.id,
      })) || [];

    return [
      ...baseOptions,
      { label: 'General Discussion', value: GENERAL_DISCUSSION_ID },
    ];
  }, [adBoardData?.sectionGroups]);

  const activityOptions = useMemo(
    () =>
      selectedGroup?.sections?.map((section) => ({
        label: `Activity ${section.index + 1} | ${i18n.t(
          makeKey('adBoardDetails.activityTypes', section.type)
        )}: ${section.title}`,
        value: section.id,
      })) || [],
    [selectedGroup]
  );
  const topicOptions = useMemo(
    () =>
      selectedActivity?.type === 'discussion'
        ? selectedActivity.content?.map(
            (content: DiscussionAdBoardSectionContentDto) => ({
              label: `Discussion ${content.index + 1} | ${
                content?.discussion?.topic
              }`,
              value: content.discussionId,
            })
          ) || []
        : [],
    [selectedActivity]
  );

  return [groupOptions, activityOptions, topicOptions];
};
